<template>
  <div class="row  q-col-gutter-xs">
    <div class="col-md-12 col-xs-12">
      <q-card class="my-card bg-amber-2">
        <q-card-section>
          <div class="row q-col-gutter-xs">
            <div class="col-md-12 col-xs-12">
              <div class="text-h6 text-center">FILTRO GLOBAL DOS GRÁFICOS</div>
            </div>
            <q-form class="col-12" ref="form">
              <div class="row q-col-gutter-xs">
                <div class="col-md-5">
                  <input type="date" class="form-control"  v-model="init" @change="changeInit" />
                </div>
                <div class="col-md-5">
                  <input type="date" class="form-control"  v-model="finish"  @change="changeFinish"/>
                </div>
                <div class="col-md-1">
                  <q-btn stretch size="lg" @click="setar" style="width:100%;" rounded label="Filtrar"/>
                </div>
                <div class="col-md-1">
                  <q-btn stretch size="lg" @click="clear" style="width:100%;" rounded label="Limpar"/>
                </div>
              </div>
            </q-form>
          </div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-md-3 col-xs-12">
      <credit-card-chart :init="getBrazilianDateString(init)" :finit="getBrazilianDateString(finish)" :change="triggerFilter"/>
    </div>
    <div class="col-md-6 col-xs-12">
      <itau-chart  :init="getBrazilianDateString(init)" :finit="getBrazilianDateString(finish)" :change="triggerFilter"/>
    </div>
    <div class="col-md-3 col-xs-12">
      <santander v-if="checkIfSantanderShouldRender()" :init="getBrazilianDateString(init)" :finit="getBrazilianDateString(finish)" :change="triggerFilter"/>
    </div>
    <div class="col-md-3 col-xs-12">
      <total :init="getBrazilianDateString(init)" :finit="getBrazilianDateString(finish)" :change="triggerFilter"/>
    </div>
    <div class="col-md-3 col-xs-12">
      <pix-chart :init="getBrazilianDateString(init)" :finit="getBrazilianDateString(finish)" :change="triggerFilter"/>
    </div>

  </div>
</template>

<script>
import Total from './Total';
// import ChartTrasnferencia2 from './ChartTransferencia2';
// import ChartTrasnferencia from './ChartTransferencia';
import Santander from './Santander';
import ItauChart from './Itau';
import CreditCardChart from './CreditCardChart';
import PixChart from './PixChart';
import { getBrazilianDateString } from '../helpers'
// import Extras from './Extras';
export default {
  name: 'MidianCharts',
  components: { CreditCardChart, ItauChart, Santander, Total, PixChart },
  data () {
    return {
      init: '',
      finish: '',
      triggerFilter: false,
      canFilter: false
    };
  },
  methods: {
    setar () {
      if (this.canFilter) {
        this.triggerFilter = true;
        this.canFilter = false;
      };
    },
    clear () {
      this.triggerFilter = false;
      this.canFilter = false;
      this.init = '';
      this.finish = '';
    },
    checkIfSantanderShouldRender () {
      const startDate = this.init ? new Date(this.init + ' ') : new Date();
      return startDate.getTime() < new Date('2022-06-01').getTime();
    },
    getBrazilianDateString (date) {
      return date ? getBrazilianDateString(date) : '';
    },
    changeInit (event) {
      const value = event.target;
      this.canFilter = value !== this.init && this.finish;
      this.triggerFilter = false;
    },
    changeFinish (event) {
      const value = event.target;
      this.canFilter = value !== this.finish && this.init;
      this.triggerFilter = false;
    }
  }
};
</script>

<style scoped>

</style>
